import { useState } from "react";
import { emptyPlatoForm, platoToForm } from "../domain/platosForm";

export function usePlatoForm() {
    const [formVisible, setFormVisible] = useState(false);
    const [editingPlato, setEditingPlato] = useState(null);
    const [formData, setFormData] = useState(emptyPlatoForm());

    const openCreate = () => {
        setEditingPlato(null);
        setFormData(emptyPlatoForm());
        setFormVisible(true);
    };

    const openEdit = (plato) => {
        setEditingPlato(plato);
        setFormData(platoToForm(plato));
        setFormVisible(true);
    };

    const close = () => setFormVisible(false);

    const reset = () => {
        setEditingPlato(null);
        setFormData(emptyPlatoForm());
    };

    return {
        formVisible, setFormVisible,
        editingPlato,
        formData, setFormData,
        openCreate, openEdit, close, reset,
    };
}
